import { Injectable, inject } from "@angular/core";

import { StorageService } from "@hermes/core-app-core";

export const REMOTE_RDV_APPOINTMENT_ID_KEY = "REMOTE_RDV_APPOINTMENT_ID";
const REMOTE_RDV_APPOINTMENT_ID_TTL_MINUTES = 4 * 60;

@Injectable({ providedIn: "root" })
export class RemoteAppointmentIdStorageService {
    readonly #storageService = inject(StorageService);

    public save(appointmentId: string): void {
        this.#storageService.setLocalStorageItem(
            REMOTE_RDV_APPOINTMENT_ID_KEY,
            appointmentId,
            REMOTE_RDV_APPOINTMENT_ID_TTL_MINUTES,
        );
    }

    public get(): string | undefined {
        const appointmentId: string | undefined =
            this.#storageService.getLocalStorageItem(
                REMOTE_RDV_APPOINTMENT_ID_KEY,
            );

        return appointmentId;
    }

    public clear(): void {
        this.#storageService.removeLocalStorageItem(
            REMOTE_RDV_APPOINTMENT_ID_KEY,
        );
    }
}
